export default import.meta.ROLLDOWN_FILE_URL_FKNdLzKnlftW3t_gzo81yw